import { trackSigninHcaptchaApiLatencyTimingPair } from "@faire/web-api--source/events/signin/actionCategoryOther/hcaptchaApiLatencyTimingPair";
import { ILoginRequest } from "@faire/web-api--source/indigofair/data/ILoginRequest";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
import { TimingMarker } from "@faire/web/common/timings/TimingMarker";
import { useCallback } from "react";

import { useFetchWidgetID } from "./useFetchWidgetId";

/**
 * Call hcaptcha.execute() to get the token.
 */
export const useFetchHCaptchaData = () => {
  const { widgetError } = useFetchWidgetID();

  const fetchHCaptchaData = useCallback(
    async (
      widgetID: string | undefined
    ): Promise<ILoginRequest.IHCaptchaData> => {
      if (widgetError) {
        return Promise.reject(new Error(widgetError));
      }
      if (!widgetID) {
        return Promise.reject(
          new Error(ILoginRequest.IHCaptchaData.HCaptchaError.NO_WIDGET)
        );
      }

      const hcaptcha = getGlobalProperty<HCaptcha | undefined>("hcaptcha");
      if (!hcaptcha?.execute) {
        return Promise.reject(
          new Error(ILoginRequest.IHCaptchaData.HCaptchaError.NO_SCRIPT)
        );
      }

      const fetchedAt = Date.now();

      const start = new TimingMarker();
      const res = await hcaptcha.execute(widgetID, { async: true });
      const end = new TimingMarker();

      trackSigninHcaptchaApiLatencyTimingPair({
        start,
        end,
      });

      if (!res?.response) {
        return Promise.reject(
          new Error(ILoginRequest.IHCaptchaData.HCaptchaError.NO_TOKEN)
        );
      }

      return ILoginRequest.IHCaptchaData.build({
        token: res.response,
        token_fetched_at: fetchedAt,
      });
    },
    [widgetError]
  );

  return { fetchHCaptchaData };
};
